import * as TierGroups from 'marketplace-ui-common/constants/groupTags/TierGroups';
const orderedTierArrays = [TierGroups.CRM, TierGroups.MARKETING, TierGroups.SALES, TierGroups.SERVICE, TierGroups.CONTENT, TierGroups.OPERATIONS];
const flattenedTierOrder = orderedTierArrays.flat();
export function getLowestTier(tiers) {
  return tiers.sort((tierA, tierB) => flattenedTierOrder.indexOf(tierA) - flattenedTierOrder.indexOf(tierB))[0];
}